<template>
  <div>
    <!-- Mensaje explicativo por ser un producto especial-complejo -->
    <div class="alert alert-info mb-4">
      <h4><i class="fas fa-info-circle"></i> {{ $t('productoEspecialDetectado') }}</h4>
      <p>
        {{ getMensajeExplicativo() }}
      </p>
    </div>

    <!-- Crear producto solo con o suple -->
    <div class="alert alert-light mb-4" v-if="shouldShowSupl() || shouldShowCon()">
      <label class="minimal-checkbox-label">
        <input type="checkbox" v-model="omitirProductoNormal" class="minimal-checkbox" @change="onOmitirNormalChange" />
        <span class="minimal-checkmark"></span>
        <div class="minimal-text">
          <span class="minimal-title">{{ $t('crearProductoSinNormal') }}</span>
          <span class="minimal-desc">{{ $t('crearProductoSinNormalExplicacion') }}</span>
        </div>
      </label>

      <div class="minimal-info-panel" v-if="omitirProductoNormal">
        <div class="minimal-info-content d-flex align-items-start">
          <i class="fas fa-info-circle me-2"></i>
          <div>
            <span>{{ $t('crearProductoSinNormalDetalle') }}</span>
            <br>
            <span class="mt-1 d-block" style="color: #856404;">
              {{ $t('crearProductoSinNormalImportante') }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Formulario para producto NORMAL -->
    <transition name="slide-fade">
      <div class="product-section" :class="{ 'section-disabled': omitirProductoNormal }" v-if="shouldShowNormal()">
        <div class="section-header" v-if="omitirProductoNormal">
          <div class="disabled-overlay">
            <div class="disabled-content">
              <i class="fas fa-eye-slash"></i>
              <h5>{{ $t('productoNormalOculto') }}</h5>
              <p class="text-muted small mb-0">{{ $t('productoNormalOcultoExplicacion') }}</p>
              <button class="btn btn-sm btn-info mt-3" @click="omitirProductoNormal = false">
                {{ $t('activarProducto') }}
              </button>
            </div>
          </div>
        </div>

        <div class="section-content" :class="{ 'content-blurred': omitirProductoNormal }">
          <h3>
            <i class="fas fa-cube"></i>
            {{ $t('productoNormal') }}
            <span v-if="omitirProductoNormal" class="badge badge-warning ml-2">
              <i class="fas fa-eye-slash"></i> Inactivo
            </span>
          </h3>
          <producto-combinado ref="normalForm" :key="'normal'" :product="productos.normal" :show-sections="{
            basicInfo: true,
            colorPicker: true,
            pricing: true,
            advanced: true,
            taxes: true,
            suplementPrice: false
          }" :categories="listCategoriesByBusiness" :iva-types="['21%', '10%', '4%']" :disabled="omitirProductoNormal"
            :max-name-length="50" :selected-tpv-server-list="selectedTpvServerList" :notBasicProduct="false"
            :product-data-info="productDataInfo" @update:product="updateProduct('normal', $event)" />
        </div>
      </div>
    </transition>

    <!-- Formulario para producto CON -->
    <div class="product-section mt-4" v-if="shouldShowCon()">
      <h3><i class="fas fa-plus-circle" style="color: #f39c12;"></i> {{ $t('productoCON') }}</h3>
      <producto-combinado ref="conForm" :key="'con'" :product="productos.con" :show-sections="{
        basicInfo: true,
        colorPicker: true,
        pricing: false,
        advanced: true,
        taxes: false,
        suplementPrice: false
      }" :categories="listCategoriesByBusiness" :disabled="false" :max-name-length="50"
        :selected-tpv-server-list="selectedTpvServerList" :notBasicProduct="true"
        @update:product="updateProduct('con', $event)" />
    </div>

    <!-- Formulario para producto SUPLEMENTO -->
    <div class="product-section mt-4" v-if="shouldShowSupl()">
      <h3><i class="fas fa-plus" style="color: #3498db;"></i> {{ $t('productoSUPL') }}</h3>
      <producto-combinado ref="suplForm" :key="'suplemento'" :product="productos.suplemento" :show-sections="{
        basicInfo: true,
        colorPicker: true,
        pricing: false,
        advanced: true,
        taxes: false,
        suplementPrice: true
      }" :categories="listCategoriesByBusiness" :disabled="false" :max-name-length="50"
        :selected-tpv-server-list="selectedTpvServerList" :notBasicProduct="true"
        @update:product="updateProduct('suplemento', $event)" />
    </div>

    <!-- Modal de validación de campos obligatorios -->
    <modal name="validation-errors" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
      <div>
        <div class="modal-header wrapperTitle">
          <h4 style="margin: 0px">{{ $t('validationError') }}</h4>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="d-flex align-items-start p-3"
                style="background-color: #ffe5e5; border-left: 4px solid #ff4d4f; border-radius: 6px; box-shadow: 0 2px 6px rgba(0,0,0,0.1);">
                <!-- Icono -->
                <!-- <div class="me-4">
                  <i class="fas fa-exclamation-triangle fa-lg" style="color: #ff4d4f;"></i>
                </div> -->
                <!-- Contenido -->
                <div>
                  <strong style="color: #b30000; font-size: 1.1rem;">{{ $t('pleaseFillRequiredFields') }}</strong>
                  <ul class="mt-2 mb-0" style="padding-left: 1.2rem; color: #4d0000;">
                    <li v-for="(error, index) in validationErrors" :key="index">
                      {{ error }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="closeValidationModal" class="btn btn-secondary">
              <!-- <i class="fas fa-times"></i> {{ $t("cerrar") }} -->
              {{ $t("cerrar") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <!-- Modal informativo sobre un producto computado: Más de una unidad de medida y a la vez, es CON/SUPLE -->
    <modal name="product-computed" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
      <div>
        <div class="modal-header wrapperTitle">
          <h4 style="margin: 0px">{{ $t('atencion') }}</h4>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="d-flex align-items-start p-3"
                style="background-color: #ffc107; border-left: 4px solid #ffa500; border-radius: 6px; box-shadow: 0 2px 6px rgba(0,0,0,0.1);">
                <!-- Icono -->
                <!-- <div class="me-4">
                  <i class="fas fa-exclamation-triangle fa-lg" style="color: #ffa500;"></i>
                </div> -->
                <!-- Contenido -->
                <div style="text-align: justify;">
                  <strong style="color: #725000; font-size: 1.1rem;">{{ $t('productComputedInfo') }}</strong>
                  <ul class="mt-2 mb-0" style="padding-left: 1.2rem; color: #4d0000;">
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="closeComputedProduct" class="btn btn-primary">
              {{ $t("continuar") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
import VueNumeric from 'vue-numeric';
import { Select, Option, Checkbox } from 'element-ui';
import swal from 'sweetalert2'
import ProductoCombinado from '@/pages/Widgets/Productos/ProductoCombinado.vue';

export default {
  name: 'ProductoFormCompleto',
  components: {
    'el-select': Select,
    'el-option': Option,
    'el-checkbox': Checkbox,
    'vue-numeric': VueNumeric,
    'producto-combinado': ProductoCombinado
  },

  props: {
    savedFormData: {
      type: Object,
      default: null
    },
    type: Boolean,
    continueButtonPressedOnStep3: {
      default: false
    },
    productoSeleccionado: {
      type: Object,
      required: true
    },
    selectedTpvServerList: {
      type: Array,
      required: true
    },
    listCategoriesByBusiness: {
      type: Array,
      default: () => []
    },
    listDepartamentos: {
      type: Array,
      default: () => []
    },
    finalizeButtonPressed: {
      type: Boolean,
      default: false
    },
    productosPorTpvRecuperados: {
      type: [Array, Object],
      default: () => ([])
    },
    productsDataToFillForm: {
      type: Array,
      default: () => []
    },
    productTypeFlags: {
      type: Object,
      default: () => ({
        type_swap_con_to_suple: false,
        type_swap_suple_to_con: false,
        type_add_suple: false,
        type_add_con: false,
        type_remove_suple: false,
        type_remove_con: false,
        type_remove_all_con_suple: false,
        type_new_con: false,
        type_new_suple: false,
        type_new_con_suple: false,
        type_invalid_transmutation: false,
        requires_full_form: true,
        transparent_update: false
      })
    },
    productDataInfo: {
      type: Object,
      default: () => ({})
    },
    resetProductoFormBasico: {
      type: Boolean,
      default: false
    },
    savedFormData: {
      type: Object,
      default: null
    },
    isNewProduct: {
      type: Boolean,
      default: true
    },
    ignoreMultipleUDMedida: {
      type: Boolean,
      default: false
    }
    // validationErrors: {
    //   type: Array,
    //   default: () => []
    // }
  },

  data() {
    return {
      validationErrors: [],
      // Datos del formulario para cada tipo de producto
      productos: {
        normal: {
          nombreProducto: '',
          descripcion: '',
          codigoBarras: '',
          color: 'amarillo',
          idCategory: null,
          iva: '21%',
          price1: 0,
          price2: 0,
          price3: 0,
          price4: 0,
          selPrice1: false,
          selPrice2: false,
          selPrice3: false,
          selPrice4: false,
          esCombo: false,
          tienePeso: false,
          type: 'normal',
          orden: 999,
          baja: false,
          descuento: false,
          isMenu: false,
          menuType: ''
        },
        con: {
          nombreProducto: '',
          descripcion: '',
          codigoBarras: '',
          color: 'amarillo',
          idCategory: null,
          type: 'con',
          orden: 999,
          baja: false,
          descuento: false,
          isMenu: false,
          menuType: ''
        },
        suplemento: {
          nombreProducto: '',
          descripcion: '',
          codigoBarras: '',
          color: 'amarillo',
          idCategory: null,
          type: 'suplemento',
          orden: 999,
          baja: false,
          descuento: false,
          isMenu: false,
          menuType: ''
        },
      },
      isProcessing: false,
      omitirProductoNormal: false,
    };
  },

  computed: {
    // Determina qué tipos de productos necesitamos mostrar
    productTypes() {
      const types = ['normal']; // Siempre se muestra el producto normal
      const { productTypeFlags } = this;
      const { MostrarEnListaCON, MostrarEnListaSUPLEMENTO } = this.productoSeleccionado;

      // Manejar nuevos productos
      if (this.isNewProduct) {
        if (MostrarEnListaCON) types.push('con');
        if (MostrarEnListaSUPLEMENTO) types.push('suplemento');
        return types;
      }

      // Manejar productos existentes con cambios de tipo
      const {
        type_swap_con_to_suple,
        type_swap_suple_to_con,
        type_add_suple,
        type_add_con,
        type_remove_suple,
        type_remove_con,
        type_remove_all_con_suple,
        type_new_con,
        type_new_suple,
        type_new_con_suple,
        type_invalid_transmutation,
        requires_full_form
      } = productTypeFlags;

      // Manejar cambios de tipo
      if (type_swap_con_to_suple) {
        console.log("type_swap_con_to_suple");
        types.push('suplemento');
        return types;
      }
      if (type_swap_suple_to_con) {
        console.log("type_swap_suple_to_con");
        types.push('con');
        return types;
      }

      // Manejar adiciones
      if (type_add_suple) {
        console.log("type_add_suple");
        types.push('con', 'suplemento');
        return types;
      }
      if (type_add_con) {
        console.log("type_add_con");
        types.push('con', 'suplemento');
        return types;
      }

      // Manejar eliminaciones
      if (type_remove_suple) {
        console.log("type_remove_suple");
        types.push('con');
        return types;
      }
      if (type_remove_con) {
        console.log("type_remove_con");
        types.push('suplemento');
        return types;
      }

      // Manejar eliminación completa
      if (type_remove_all_con_suple) {
        return ['normal']; // Solo mantener el producto normal
      }

      // Manejar nuevas adiciones
      if (type_new_con) {
        console.log("type_new_con");
        types.push('con');
        return types;
      }
      if (type_new_suple) {
        console.log("type_new_suple");
        types.push('suplemento');
        return types;
      }
      if (type_new_con_suple) {
        console.log("type_new_con_suple");
        types.push('con', 'suplemento');
        return types;
      }

      // Manejar transmutación inválida o formulario completo requerido
      if (requires_full_form) {
        console.log("requires_full_form");
        // Mostrar todos los formularios para el modo de formulario completo
        types.push('con', 'suplemento');
        return types;
      }

      // Caso por defecto: mantener el estado actual
      if (MostrarEnListaCON) types.push('con');
      if (MostrarEnListaSUPLEMENTO) types.push('suplemento');

      return types;
    },

    // Cantidad de productos que se crearán
    cantidadProductos() {
      return this.productTypes.length;
    }
  },

  created() {
    // console.log('selectedTpvServerList:', this.selectedTpvServerList);
    // console.log(this.productoSeleccionado);
  },

  mounted() {
    console.log('productTypeFlags:', this.productTypeFlags);
    console.log('Product Types:', this.productTypes);
    console.log('isNewProduct', this.isNewProduct);

    if (this.ignoreMultipleUDMedida) {
      this.showComputedProduct();
    }
  },

  watch: {
    // Observar cambios en los datos guardados para restaurar el formulario
    savedFormData: {
      handler(newVal) {
        // console.log("savedFormData ha cambiado: ", newVal);
        if (newVal && Object.keys(newVal).length > 0) {
          this.restoreFormData(newVal);
        }
      },
      deep: true,
      immediate: true
    },

    // Observar cambios en el producto seleccionado para inicializar los formularios
    productoSeleccionado: {
      handler(newVal) {
        if (newVal) {
          this.initializeProductos();
        }
      },
      deep: true,
      immediate: true
    },

    // Observar cambios en el botón continuar para activar la validación de formularios
    continueButtonPressedOnStep3: {
      async handler(newVal) {
        // console.log('continueButtonPressedOnStep3 changed:', newVal);
        if (newVal) {
          try {
            const isValid = await this.validateForms();
            // console.log('Validación completada. Válido?: ', isValid);

            // Emitir el evento de validación completada
            this.$emit('validation-completed', isValid);

          } catch (error) {
            // console.error('Error durante la validación de formularios:', error);
            this.validationErrors = ['Error inesperado durante la validación del formulario'];
            this.showValidationModal();
            this.$emit('validation-failed');
          }

          // Resetear el estado del botón
          this.$emit('update:continueButtonPressedOnStep3', false);
        }
      },
      immediate: true
    }
  },

  methods: {
    // Manejar cambios en el checkbox de omitir producto normal
    onOmitirNormalChange() {
      // El producto normal se ocultará/mostrará según el estado del checkbox
      // La lógica de creación se manejará en prepareProductsData()
      console.log('onOmitirNormalChange - omitirProductoNormal:', this.omitirProductoNormal);
    },

    // Restaurar los datos en los formularios correspondientes
    restoreFormData(savedData) {
      if (!savedData) return;

      // console.group("Restaurando formularios");

      try {
        const formKeys = {
          'producto': 'normal',
          'con': 'con',
          'suplemento': 'supl'
        };

        // Primero, actualizamos el estado local
        Object.entries(formKeys).forEach(([sourceKey, targetKey]) => {
          if (!savedData[sourceKey]) return;

          const formData = { ...savedData[sourceKey] };

          // console.log(`Restaurando ${sourceKey}:`, {
          //   color: formData.color,
          //   descripcion: formData.descripcion,
          //   iva: formData.iva,
          //   departments: (formData.departments && formData.departments.length) ? formData.departments.length : 0
          // });

          // Procesar departamentos
          if (formData.departments) {
            formData.departments = formData.departments.map(dept => ({
              id: dept.id,
              name: dept.name,
              iva: dept.iva || '21%',
              categoria: dept.categoria || { id: null, name: null },
              categoriaId: dept.categoriaId
                ? dept.categoriaId
                : (dept.categoria && dept.categoria.id)
                  ? dept.categoria.id
                  : null,
              availableIvas: dept.availableIvas || ['21%', '10%', '4%', '0%'],
              price1: Number(dept.price1) || 0,
              price2: Number(dept.price2) || 0,
              price3: Number(dept.price3) || 0,
              price4: Number(dept.price4) || 0
            }));
          }

          // Construir producto completo
          const productData = {
            type: targetKey,
            nombreProducto: formData.nombreProducto || '',
            productName: formData.nombreProducto || '',
            descripcion: formData.descripcion || '',
            codigoBarras: formData.codigoBarras || '',
            color: formData.color || 'amarillo',
            colorBoton: formData.colorBoton || formData.color || 'amarillo',
            iva: formData.iva || '',
            orden: formData.orden !== undefined ? formData.orden : '',
            baja: formData.baja || false,
            departments: formData.departments || []
          };

          // Campos específicos por tipo
          if (targetKey === 'normal') {
            Object.assign(productData, {
              selPrice1: formData.selPrice1 !== undefined ? formData.selPrice1 : false,
              selPrice2: formData.selPrice2 !== undefined ? formData.selPrice2 : false,
              selPrice3: formData.selPrice3 !== undefined ? formData.selPrice3 : false,
              selPrice4: formData.selPrice4 !== undefined ? formData.selPrice4 : false,
              namePrice1: formData.namePrice1 || '',
              namePrice2: formData.namePrice2 || '',
              namePrice3: formData.namePrice3 || '',
              namePrice4: formData.namePrice4 || '',
              price1: Number(formData.price1) || 0,
              price2: Number(formData.price2) || 0,
              price3: Number(formData.price3) || 0,
              price4: Number(formData.price4) || 0
            });
          } else {
            productData.idCategory = formData.idCategory || null;
            if (targetKey === 'supl') {
              productData.variacionPrecio = Number(formData.variacionPrecio) || 0;
              productData.precioSuplemento = Number(formData.precioSuplemento) || 0;
            }
          }

          // Actualizo el estado local
          this.$set(this.productos, targetKey, productData);
        });

        // Primero, creo nuevos objetos para forzar la reactividad
        const newProductos = { ...this.productos };

        // Actualizo los productos
        Object.entries(formKeys).forEach(([sourceKey, targetKey]) => {
          if (!savedData[sourceKey]) return;

          // Creo un nuevo objeto para forzar la reactividad
          newProductos[targetKey] = {
            ...this.productos[targetKey],
            ...savedData[sourceKey],
            // Me aseguro que los campos booleanos se conviertan correctamente
            selPrice1: !!savedData[sourceKey].selPrice1,
            selPrice2: !!savedData[sourceKey].selPrice2,
            selPrice3: !!savedData[sourceKey].selPrice3,
            selPrice4: !!savedData[sourceKey].selPrice4
          };

          // console.log('Datos actualizados para ' + targetKey, newProductos[targetKey]);
        });

        // Actualizo el objeto productos con los nuevos valores
        this.productos = { ...newProductos };

        // Usamos $nextTick para asegurarnos de que la UI se ha actualizado
        this.$nextTick(() => {
          // Inicializamos departamentos después de la actualización
          Object.entries(formKeys).forEach(([sourceKey, targetKey]) => {
            if (savedData[sourceKey] && savedData[sourceKey].departments) {
              const formRef = targetKey + 'Form';
              const component = Array.isArray(this.$refs[formRef])
                ? this.$refs[formRef][0]
                : this.$refs[formRef];

              if (component) {
                // console.log('Inicializando departamentos para ' + targetKey);
                if (component.initializeDepartments) {
                  component.initializeDepartments();
                }
                // Fuerzo la actualización del componente
                component.$forceUpdate();
              }
            }
          });
        });
      } catch (error) {
        console.error('Error restaurando:', error);
      } finally {
        console.groupEnd();
      }
    },

    // Método para establecer datos del producto en ProductoCombinado.vue
    setProductData(productData) {
      if (!productData) return;

      // Actualizo el product completo
      Object.keys(productData).forEach(key => {
        if (key !== 'departments') {
          this.$set(this.product, key, productData[key]);
        }
      });

      // Restaurar departamentos
      if (productData.departments && Array.isArray(productData.departments)) {
        this.departments = productData.departments.map(dept => {
          const processed = {
            id: dept.id,
            name: dept.name,
            iva: dept.iva || '21%',
            categoria: dept.categoria || { id: null, name: null },
            categoriaId: dept.categoriaId || (dept.categoria && dept.categoria.id) || null,
            availableIvas: dept.availableIvas || ['21%', '10%', '4%', '0%'],
            price1: Number(dept.price1) || 0,
            price2: Number(dept.price2) || 0,
            price3: Number(dept.price3) || 0,
            price4: Number(dept.price4) || 0
          };

          // console.log('Dept procesado:', {
          //   name: processed.name,
          //   categoriaId: processed.categoriaId,
          //   iva: processed.iva
          // });

          return processed;
        });

        // console.log('Departamentos restaurados:', this.departments.length);
      } else {
        this.departments = [];
      }

      // Forzar re-render
      this.$nextTick(() => {
        this.$forceUpdate();
        // console.log('Formulario actualizado');
      });
    },

    showComputedProduct() {
      this.$modal.show('product-computed');
    },

    closeComputedProduct() {
      this.$modal.hide('product-computed');
    },

    showValidationModal() {
      this.$modal.show('validation-errors');
    },

    closeValidationModal() {
      this.$modal.hide('validation-errors');
    },

    // Validar todos los formularios antes de continuar
    async validateForms() {
      // console.group('validateForms');

      let allValid = true;
      const allErrors = [];

      // Mapeo correcto de tipos a referencias
      const formRefs = {
        normal: 'normalForm',
        con: 'conForm',
        suplemento: 'suplForm'
      };

      // console.log("formRefs", formRefs);

      // Esperar a que los componentes estén completamente montados
      await this.$nextTick();
      await new Promise(resolve => setTimeout(resolve, 300));

      // Validar cada formulario
      for (const type of ['normal', 'con', 'suplemento']) {
        if (!this.shouldShowType(type)) {
          console.log(`Saltando el formulario ${type} (no mostrado)`);
          continue;
        }

        const refName = formRefs[type];
        const formRef = this.$refs[refName];

        // console.log(`Validando formulario ${type}, ref:`, refName, 'disponible:', !!formRef);

        // if (!formRef) {
        //   console.error(`Error al validar el formulario ${type}: referencia ${refName} no encontrada`);
        //   allErrors.push(`Error al validar el formulario ${type}: referencia ${refName} no encontrada`);
        //   allValid = false;
        //   continue;
        // }

        try {
          // Antes de validar, solicitar los datos actuales del formulario
          if (typeof formRef.getCurrentFormData === 'function') {
            const currentData = formRef.getCurrentFormData();
            this.updateProduct(type, currentData);
          }

          const result = formRef.validateForm();
          // console.log(`Resultado de validación para ${type}:`, result);

          if (!result || !result.isValid) {
            allValid = false;
            if (result && result.errors) {
              allErrors.push(...result.errors);
            }
          }
        } catch (error) {
          console.error(`Error al validar el formulario ${type}:`, error);
          allValid = false;
          allErrors.push(`Error al validar el formulario ${type}: ${error.message}`);
        }
      }

      if (!allValid) {
        this.validationErrors = allErrors;
        this.showValidationModal();
        this.$emit('validation-failed');
        console.groupEnd();
        return false;
      }

      // console.log('Todos los formularios validados. Verificando códigos de barras...');
      const barcodesOk = await this.checkProductsBarcodes();
      if (barcodesOk) {
        // console.log("Barcodes ok");
        this.continueToStep4();
        return true;
      } else {
        // console.log("Validación de barcodes falló");
        this.validationErrors = ['Error: Alguno de los códigos de barras no es válido o está duplicado'];
        this.showValidationModal();
        return false;
      }
    },

    // Verificar si se debe mostrar un tipo de producto específico
    shouldShowType(type) {
      switch (type) {
        case 'normal': return this.shouldShowNormal();
        case 'con': return this.shouldShowCon();
        case 'suplemento': return this.shouldShowSupl();
        default: return false;
      }
    },

    // Validar campos obligatorios para todos los productos
    validateRequiredFields() {
      this.validationErrors = [];
      const requiredFields = ['nombreProducto', 'idCategory'];
      let isValid = true;

      // Comprobar campos obligatorios para cada tipo de producto
      // ['normal', 'con', 'suplemento']
      ['normal'].forEach(type => {
        if (this.productos[type]) {
          const product = this.productos[type];

          requiredFields.forEach(field => {
            if (!product[field]) {
              const fieldName = this.$t(field === 'idCategory' ? 'categoria' : field);
              const productType = this.$t(`producto${type.charAt(0).toUpperCase() + type.slice(1)}`);
              this.validationErrors.push(
                `${fieldName} para el producto ${productType} es obligatorio`
              );
              isValid = false;
            }
          });
        }
      });

      return isValid;
    },

    // Validar códigos de barras para todos los tipos de productos
    async checkProductsBarcodes() {
      const vm = this;

      return new Promise((resolve) => {
        const allProducts = [];

        if (vm.shouldShowNormal() && vm.productos.normal) {
          allProducts.push({
            type: "normal",
            data: { ...vm.productos.normal },
          });
        }
        // if (vm.shouldShowCon() && vm.productos.con) {
        //   allProducts.push({
        //     type: "con",
        //     data: { ...vm.productos.con },
        //   });
        // }
        // if (vm.shouldShowSupl() && vm.productos.suplemento) {
        //   allProducts.push({
        //     type: "suplemento",
        //     data: { ...vm.productos.suplemento },
        //   });
        // }

        if (allProducts.length === 0) {
          resolve(true);
          return;
        }

        const productWithBarcode = allProducts.find(
          (p) => p.data.codigoBarras
        );

        if (!productWithBarcode) {
          resolve(true);
          return;
        }

        const config = {
          params: {
            jwt: this.$store.getters.jwt,
            barCode: productWithBarcode.data.codigoBarras,
          },
          headers: {
            Authorization: "Bearer " + this.$store.getters.jwt
          },
        };

        vm.axios
          .get(vm.$store.getters.apiUrl + "products/checkBarcodeBC", config)
          .then(function (response) {
            if (response.data.response) {
              resolve(true);
            } else {
              swal({
                title: vm.$t("atencion"),
                text:
                  response.data.message ||
                  vm.$t("errorValidandoCodigosBarras"),
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
              resolve(false);
            }
          })
          .catch(function (error) {
            console.error("Error validando código de barras:", error);
            swal({
              title: vm.$t("error"),
              text: vm.$t("errorServidor"),
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error",
            });
            resolve(false);
          });
      });
    },

    updateProduct(type, productData) {
      // console.log(`updateProduct llamado para ${type}:`, productData);

      // Crear un nuevo objeto para forzar la reactividad
      const updatedProduct = JSON.parse(JSON.stringify({
        ...this.productos[type],
        ...productData
      }));

      // Si hay departamentos, asegurarnos de que se copien correctamente
      if (productData.departments) {
        updatedProduct.departments = JSON.parse(JSON.stringify(productData.departments));
      }

      // Actualizar el producto usando $set para forzar la reactividad
      this.$set(this.productos, type, updatedProduct);

      // Forzar la actualización de la UI
      this.$nextTick(() => {
        const formRef = `${type}Form`;
        const component = this.$refs[formRef];
        if (component) {
          if (Array.isArray(component)) {
            component[0].$forceUpdate();
          } else {
            component.$forceUpdate();
          }
        }
      });
    },

    // Inicializar los datos de los productos basándose en el producto seleccionado o en productDataInfo
    initializeProductos() {
      try {
        // Si tenemos datos de productDataInfo, usamos esos
        if (this.productDataInfo && Object.keys(this.productDataInfo).length > 0) {
          this.initializeFromProductDataInfo();
          return;
        }

        // Código existente para inicializar desde productoSeleccionado
        if (!this.productoSeleccionado) return;

        // Inicializar producto normal
        this.productos.normal = {
          ...this.productos.normal,
          nombreProducto: this.productoSeleccionado.productName || this.productoSeleccionado.Description || '',
          descripcion: this.productoSeleccionado.descripcion || this.productoSeleccionado.Description || '',
          codigoBarras: this.productoSeleccionado.codigoBarras || this.productoSeleccionado.No_ || '',
          color: 'amarillo',
          idCategory: this.productoSeleccionado.categoria || null,
          iva: this.productoSeleccionado.iva || (this.productoSeleccionado.impuestoPorcentaje ? `${this.productoSeleccionado.impuestoPorcentaje}%` : '21%'),
          price1: this.productoSeleccionado.tarifa1 || this.productoSeleccionado.Price || 0,
          price2: this.productoSeleccionado.tarifa2 || 0,
          price3: this.productoSeleccionado.tarifa3 || 0,
          price4: this.productoSeleccionado.tarifa4 || 0,
          selPrice1: false,
          selPrice2: false,
          selPrice3: false,
          selPrice4: false
        };

        // Inicializar producto CON si es necesario
        if (this.productoSeleccionado.MostrarEnListaCON) {
          const conCategory = this.getCategoriaByName('CON');

          // Si no se encuentra la categoría CON, usar la primera categoría disponible
          let defaultCategory = null;
          if (this.listCategoriesByBusiness && this.listCategoriesByBusiness.length > 0 &&
            this.listCategoriesByBusiness[0].categories && this.listCategoriesByBusiness[0].categories.length > 0) {
            defaultCategory = this.listCategoriesByBusiness[0].categories[0].id;
          }

          this.productos.con = {
            ...this.productos.con,
            nombreProducto: this.productoSeleccionado.productName || this.productoSeleccionado.Description || '',
            descripcion: this.productoSeleccionado.descripcion || this.productoSeleccionado.Description || '',
            codigoBarras: this.productoSeleccionado.codigoBarras || this.productoSeleccionado.No_ || '',
            color: 'amarillo',
            idCategory: conCategory || defaultCategory
          };
        }

        // Inicializar producto SUPLEMENTO si es necesario
        if (this.productoSeleccionado.MostrarEnListaSUPLEMENTO) {
          const suplCategory = this.getCategoriaByName('SUPLEMENTO');

          // Si no se encuentra la categoría SUPLEMENTO, usar la primera categoría disponible
          let defaultCategory = null;
          if (this.listCategoriesByBusiness && this.listCategoriesByBusiness.length > 0 &&
            this.listCategoriesByBusiness[0].categories && this.listCategoriesByBusiness[0].categories.length > 1) {
            defaultCategory = this.listCategoriesByBusiness[0].categories[1].id;
          }

          this.productos.suplemento = {
            ...this.productos.suplemento,
            nombreProducto: this.productoSeleccionado.productName || this.productoSeleccionado.Description || '',
            descripcion: this.productoSeleccionado.descripcion || this.productoSeleccionado.Description || '',
            codigoBarras: this.productoSeleccionado.codigoBarras || this.productoSeleccionado.No_ || '',
            color: 'amarillo',
            idCategory: suplCategory || defaultCategory
          };
        }
      } catch (error) {
        console.error('Error inicializando los productos:', error);
      }
    },

    // Inicializar los productos desde los datos de productDataInfo
    initializeFromProductDataInfo() {
      try {
        // Inicializar los productos con valores por defecto
        this.productos = {
          normal: this.getEmptyProduct('normal'),
          con: this.getEmptyProduct('con'),
          suplemento: this.getEmptyProduct('suplemento')
        };

        // Variable para almacenar el nombre del producto normal
        let nombreProductoNormal = '';

        // Primera pasada: obtener el nombre del producto normal
        Object.entries(this.productDataInfo.tpvs || {}).forEach(([tpvId, tpvData]) => {
          if (!tpvData || !tpvData.productos || !Array.isArray(tpvData.productos)) return;

          tpvData.productos.forEach(productoData => {
            const producto = productoData.producto || {};
            const isConSuple = producto.isConSuple === true;
            const plu3 = (producto.PLU3 || '').toLowerCase();

            // Determinar el tipo de producto
            let productType = 'normal';
            if (isConSuple && plu3 === 'con') {
              productType = 'con';
            } else if (isConSuple && plu3 === 'suplemento') {
              productType = 'suplemento';
            }

            // Capturar el nombre del producto normal (del primer TPV que lo tenga)
            if (productType === 'normal' && !nombreProductoNormal) {
              nombreProductoNormal = producto.name || '';
            }
          });
        });

        // Segunda pasada: procesar todos los productos usando el nombre capturado
        Object.entries(this.productDataInfo.tpvs || {}).forEach(([tpvId, tpvData]) => {
          if (!tpvData || !tpvData.productos || !Array.isArray(tpvData.productos)) return;

          // Procesar cada producto en el TPV actual
          tpvData.productos.forEach(productoData => {
            const producto = productoData.producto || {};
            const isConSuple = producto.isConSuple === true;
            const plu3 = (producto.PLU3 || '').toLowerCase();

            // Determinar el tipo de producto basado en PLU2 o isConSuple
            let productType = 'normal';
            if (isConSuple && plu3 === 'con') {
              productType = 'con';
            } else if (isConSuple && plu3 === 'suplemento') {
              productType = 'suplemento';
            }

            // Mapear los datos del producto al formato esperado
            const mappedProduct = {
              // Usar nombreProductoNormal para productos 'con' y 'suplemento'
              nombreProducto: (productType === 'con' || productType === 'suplemento')
                ? nombreProductoNormal
                : (producto.name || ''),
              descripcion: producto.description || '',
              codigoBarras: producto.barCode || '',
              color: (producto.color || 'amarillo').toLowerCase(),
              idCategory: producto.idCategory || null,
              iva: producto.vatType ? `${parseFloat(producto.vatType)}%` : '21%',
              price1: parseFloat(producto.price1) || 0,
              price2: parseFloat(producto.price2) || 0,
              price3: parseFloat(producto.price3) || 0,
              price4: parseFloat(producto.price4) || 0,
              namePrice1: producto.namePrice1 || '',
              namePrice2: producto.namePrice2 || '',
              namePrice3: producto.namePrice3 || '',
              namePrice4: producto.namePrice4 || '',
              selPrice1: producto.selPrice1 === '1',
              selPrice2: producto.selPrice2 === '1',
              selPrice3: producto.selPrice3 === '1',
              selPrice4: producto.selPrice4 === '1',
              orden: producto.orden || '',
              plu: producto.PLU1 || '',
              plu2: producto.PLU2 || '',
              plu3: producto.PLU3 || '',
              plu4: producto.PLU4 || '',
              type: productType,
              id: producto.id || null,
              idTpv: producto.idTpv || tpvId,
              // Agregamos el ID del TPV como prefijo a los IDs para evitar duplicados
              uniqueId: `${tpvId}_${producto.id || ''}`,
              active: producto.active !== undefined ? parseInt(producto.active) : 1
            };

            // Para el producto normal, tomamos los datos del primer TPV que los tenga
            if (productType === 'normal' && !this.productos.normal.id) {
              this.productos.normal = { ...this.productos.normal, ...mappedProduct };
            }
            // Para los productos con, los combinamos si hay múltiples TPVs
            else if (productType === 'con') {
              this.productos.con = {
                ...this.productos.con,
                ...mappedProduct,
                // Mantenemos un array de IDs de TPVs para referencia
                tpvIds: [...(this.productos.con.tpvIds || []), tpvId]
              };
            }
            // Para los productos suplemento, los manejamos de forma independiente
            else if (productType === 'suplemento') {
              this.productos.suplemento = {
                ...this.productos.suplemento,
                ...mappedProduct,
                // Asignar el precio del suplemento si está disponible
                precioSuplemento: parseFloat(producto.variacionPrecio) || 0,
                // Mantenemos un array de IDs de TPVs para referencia
                tpvIds: [...(this.productos.suplemento.tpvIds || []), tpvId]
              };
            }
          });
        });

        // IMPORTANTE: Asignar el nombre del producto normal a 'con' y 'suplemento' 
        // incluso si no vienen en el JSON o si vienen vacíos, ya que no se podrá editar
        if (nombreProductoNormal) {
          if (!this.productos.con.nombreProducto || this.productos.con.nombreProducto === '') {
            this.productos.con.nombreProducto = nombreProductoNormal;
          }
          if (!this.productos.suplemento.nombreProducto || this.productos.suplemento.nombreProducto === '') {
            this.productos.suplemento.nombreProducto = nombreProductoNormal;
          }
        }
        if (this.productos.normal.active === 0) {
          this.omitirProductoNormal = true;
          this.onOmitirNormalChange();
        }

        // Forzar actualización de los componentes hijos
        this.$nextTick(() => {
          if (this.$refs.normalForm) this.$refs.normalForm.syncWithParent();
          if (this.$refs.conForm) this.$refs.conForm.syncWithParent();
          if (this.$refs.suplForm) this.$refs.suplForm.syncWithParent();
        });

      } catch (error) {
        console.error('Error inicializando desde productDataInfo:', error);
      }
    },

    // Obtener un producto vacío del tipo especificado
    getEmptyProduct(type) {
      return {
        nombreProducto: '',
        descripcion: '',
        codigoBarras: '',
        color: 'amarillo',
        idCategory: null,
        iva: '21%',
        price1: 0,
        price2: 0,
        price3: 0,
        price4: 0,
        namePrice1: '',
        namePrice2: '',
        namePrice3: '',
        namePrice4: '',
        selPrice1: false,
        selPrice2: false,
        selPrice3: false,
        selPrice4: false,
        orden: '',
        plu: '',
        plu2: type === 'con' ? 'CON-SUPLEMENTO' : type === 'suplemento' ? 'SUPLEMENTO' : 'SIMPLE',
        plu3: type === 'con' ? 'CON' : '',
        plu4: 'UNID',
        type: type,
        id: null,
        idTpv: null,
        variacionPrecio: null,
        active : 1
      };
    },

    // Obtener el ID de una categoría por su nombre
    getCategoriaByName(nombre) {
      if (!this.listCategoriesByBusiness || !Array.isArray(this.listCategoriesByBusiness)) {
        return null;
      }

      // Buscar en todas las categorías de todos los negocios
      for (const business of this.listCategoriesByBusiness) {
        if (business.categories && Array.isArray(business.categories)) {
          const categoria = business.categories.find(cat => cat.name === nombre);
          if (categoria) {
            return categoria.id;
          }
        }
      }
      return null;
    },

    // Generar el mensaje explicativo según los tipos de producto
    getMensajeExplicativo() {
      let mensaje = this.$t('productoEspecialDetectadoMensaje') + ' ';
      if (this.productoSeleccionado.MostrarEnListaCON && this.productoSeleccionado.MostrarEnListaSUPLEMENTO) {
        mensaje += this.$t('seCrearanTresProductos', { cantidad: this.cantidadProductos });
      } else if (this.productoSeleccionado.MostrarEnListaCON) {
        mensaje += this.$t('seCrearanDosProductosCon', { cantidad: this.cantidadProductos });
      } else if (this.productoSeleccionado.MostrarEnListaSUPLEMENTO) {
        mensaje += this.$t('seCrearanDosProductosSuplemento', { cantidad: this.cantidadProductos });
      }
      mensaje += ' ' + this.$t('relleneFormularios');
      return mensaje;
    },

    // Determina si debe mostrar el formulario normal
    shouldShowNormal() {
      // El producto normal siempre se muestra porque siempre se crea
      return true;
    },

    // Determina si debe mostrar el formulario CON
    shouldShowCon() {
      return this.productTypes.includes('con');
    },

    // Determina si debe mostrar el formulario SUPLEMENTO
    shouldShowSupl() {
      return this.productTypes.includes('suplemento');
    },

    // Prepara los datos de los productos para enviar al componente padre
    prepareProductsData() {
      const result = {};

      // Obtener departamentos si existen en el producto normal
      let departmentsData = [];
      if (this.productos.normal && this.productos.normal.departments) {
        departmentsData = this.productos.normal.departments.map(dept => ({
          id: dept.id,
          name: dept.name
        }));
      }

      // Procesar cada tipo de producto
      ['normal', 'con', 'suplemento'].forEach(type => {
        const producto = this.productos[type];
        if (!producto) return;
        // console.log("Preparar el objeto como requiere el back");

        // Base común
        let newProducto = {
          nombreProducto: producto.nombreProducto || '',
          descripcion: producto.descripcion || '',
          codigoBarras: producto.codigoBarras || '',
          color: producto.color || '',
          iva: producto.iva || '',
          orden: producto.orden || '',
          productName: producto.nombreProducto || '',
          colorBoton: producto.color || '',
          departments: departmentsData
        };

        if (type === 'normal') {
          newProducto.namePrice1 = producto.namePrice1 || '';
          newProducto.namePrice2 = producto.namePrice2 || '';
          newProducto.namePrice3 = producto.namePrice3 || '';
          newProducto.namePrice4 = producto.namePrice4 || '';
          newProducto.selPrice1 = producto.selPrice1 || false;
          newProducto.selPrice2 = producto.selPrice2 || false;
          newProducto.selPrice3 = producto.selPrice3 || false;
          newProducto.selPrice4 = producto.selPrice4 || false;
          newProducto.isActive = !this.omitirProductoNormal;

          newProducto.price1 = parseFloat(producto.price1) || 0;
          newProducto.price2 = parseFloat(producto.price2) || 0;
          newProducto.price3 = parseFloat(producto.price3) || 0;
          newProducto.price4 = parseFloat(producto.price4) || 0;
          newProducto.idCategory = producto.idCategory || null;
        }

        // Campos específicos para productos CON y SUPLEMENTO
        if (type === 'con' || type === 'suplemento') {
          // console.log("Establecer las categorias con suple a mano");
          newProducto.idCategory = 0;
        }

        // Campos específicos para productos normales
        if (type === 'normal' && producto.departments) {
          newProducto.departments = producto.departments.map(dept => ({
            id: dept.id,
            name: dept.name,
            iva: dept.iva,
            categoria: {
              id: dept.categoriaId || (dept.categoria ? dept.categoria.id : null),
              name: dept.categoria ? dept.categoria.name : null
            },
            price1: dept.price1 || 0,
            price2: dept.price2 || 0,
            price3: dept.price3 || 0,
            price4: dept.price4 || 0
          }));
        }

        // Solo para suplementos, agregar variacionPrecio
        if (type === 'suplemento' && producto.precioSuplemento !== undefined) {
          console.log("Creando variacion de precio producto suple");
          newProducto.variacionPrecio = producto.precioSuplemento;
        }

        // Guardo el producto en la key correspondiente
        if (type === 'normal') result.producto = newProducto;
        if (type === 'con') result.con = newProducto;
        if (type === 'suplemento') result.suplemento = newProducto;
      });

      // console.log('prepareProductsData - result final:', result);
      return result;
    },

    // Continúa al siguiente paso si la validación es exitosa
    continueToStep4() {
      // Verificar si ya estamos procesando para evitar múltiples emisiones
      if (this.isProcessing) return;

      this.isProcessing = true;
      console.log('continueToStep4', this.productos);
      this.$emit('continue-to-step4', this.prepareProductsData());

      // Resetear el flag después de un tiempo para permitir futuras emisiones
      setTimeout(() => {
        this.isProcessing = false;
      }, 1000);
    }
  }
}
</script>

<style scoped>
.producto-form-completo {
  padding: 20px;
}

.product-section {
  margin-bottom: 30px;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f9f9f9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.product-section h3 {
  margin-top: 0;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #3498db;
  color: #2c3e50;
  font-weight: bold;
}

.form-layout {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
}

.col-md-6 {
  flex: 0 0 50%;
  max-width: 50%;
  padding: 0 15px;
  box-sizing: border-box;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #34495e;
}

.form-control {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  height: 38px;
  line-height: 1.5;
  transition: border-color 0.3s;
}

.form-control:focus {
  border-color: #3498db;
  outline: none;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}

textarea.form-control {
  min-height: 100px;
  resize: vertical;
}

.form-control:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

/* Estilos de tabla para el departamento, categoría, IVA */
.table {
  width: 100%;
  margin-bottom: 1rem;
  background-color: transparent;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border: 1px solid #dee2e6;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  background-color: #f8f9fa;
  font-weight: bold;
  text-align: left;
}

.table-bordered {
  border: 1px solid #dee2e6;
}

.table-bordered th,
.table-bordered td {
  border: 1px solid #dee2e6;
}

.colors-form {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -5px 15px;
}

.radio {
  padding: 0 5px;
  margin-bottom: 10px;
}

.radio input[type="radio"] {
  display: none;
}

.radio label {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  margin: 0;
  padding: 5px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.radio label:hover {
  background-color: #f0f0f0;
}

.colorWrap {
  width: 42px;
  height: 42px;
  border: 1px solid #888;
  border-radius: 3px;
  margin-bottom: 5px;
  cursor: pointer;
  transition: all 0.2s;
}

.radio input[type="radio"]:checked+.colorWrap {
  border: 2px solid #3498db;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.5);
}

.mb-3 {
  margin-bottom: 1rem !important;
}

/* Acciones del formulario */
.form-actions {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 2px solid #e0e0e0;
  text-align: right;
}

.btn {
  margin-left: 10px;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  display: inline-block;
  transition: background-color 0.3s;
}

.btn-primary {
  background-color: #3498db;
  color: white;
}

.btn-primary:hover {
  background-color: #2980b9;
}

.btn-secondary {
  background-color: #95a5a6;
  color: white;
}

.btn-secondary:hover {
  background-color: #7f8c8d;
}

.alert {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
}

.alert-info {
  color: #31708f;
  background-color: #d9edf7;
  border-color: #bce8f1;
}

.alert h4 {
  margin-top: 0;
  color: inherit;
}

/* Asegurar que los inputs de tipo número no muestren los botones de incremento y decremento */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  -moz-appearance: textfield;
  appearance: none;
  margin: 0;
}

input[type="number"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

/* Asegurar que los formularios estén correctamente alineados */
.align-items-center {
  align-items: center !important;
}

/* Estilos personalizados para los botones de radio */
.radio {
  position: relative;
  padding-left: 30px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 3px;
}

.radio:hover input~.checkmark {
  background-color: #f1f1f1;
}

.radio input:checked~.checkmark {
  background-color: #2196F3;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.radio input:checked~.checkmark:after {
  display: block;
}

.radio .checkmark:after {
  left: 7px;
  top: 3px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.colorWrap {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: middle;
}

/* Asegurar que los selectores sean visibles */
.el-select {
  width: 100%;
}

.el-select .el-input__inner {
  height: 38px;
  line-height: 38px;
  padding: 0 15px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.el-select .el-input__inner:focus {
  border-color: #409EFF;
  outline: none;
}

/* Asegurar que las opciones del selector sean visibles */
.el-select-dropdown {
  z-index: 9999 !important;
}

/* Estilos personalizados para los radio buttons de opciones de producto */
.custom-radio-wrapper {
  margin-bottom: 15px;
}

.radio-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.custom-radio-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fff;
  transition: all 0.3s ease;
  margin-bottom: 0;
}

.custom-radio-label:hover {
  border-color: #3498db;
  background-color: #f8f9fa;
}

.custom-radio-label input[type="radio"] {
  display: none;
}

.custom-radio-label .radio-mark {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #ddd;
  border-radius: 50%;
  background-color: #fff;
  transition: all 0.3s ease;
  margin-right: 12px;
  flex-shrink: 0;
}

.custom-radio-label input[type="radio"]:checked+.radio-mark {
  background-color: #3498db;
  border-color: #3498db;
}

.custom-radio-label input[type="radio"]:checked+.radio-mark:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: white;
}

.custom-radio-label .radio-content {
  flex: 1;
}

.custom-radio-label .radio-content strong {
  display: block;
  margin-bottom: 2px;
  color: #2c3e50;
}

.custom-radio-label .radio-content small {
  color: #6c757d;
  font-weight: normal;
}

.custom-radio-label input[type="radio"]:checked~.radio-content strong {
  color: #3498db;
}

/* Estilos minimalistas para el checkbox */
.minimal-checkbox-label {
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  margin: 0;
  padding: 16px;
  border-radius: 8px;
  transition: all 0.2s ease;
  background: white;
  border: 1px solid #dee2e6;
}

.minimal-checkbox-label:hover {
  background-color: #f8f9fa;
  border-color: #5dade2;
  box-shadow: 0 2px 8px rgba(93, 173, 226, 0.15);
  transform: translateY(-1px);
}

.minimal-checkbox {
  display: none;
}

.minimal-checkmark {
  width: 20px;
  height: 20px;
  border: 2px solid #5dade2;
  border-radius: 4px;
  margin-right: 12px;
  margin-top: 2px;
  flex-shrink: 0;
  transition: all 0.2s ease;
  position: relative;
  background: white;
}

.minimal-checkbox:checked+.minimal-checkmark {
  background-color: #5dade2;
  border-color: #5dade2;
  box-shadow: 0 0 0 3px rgba(93, 173, 226, 0.2);
}

.minimal-checkbox:checked+.minimal-checkmark:after {
  content: "";
  position: absolute;
  left: 5px;
  top: 2px;
  width: 5px;
  height: 9px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.minimal-text {
  flex: 1;
}

.minimal-title {
  display: block;
  font-weight: 600;
  color: #2c3e50;
  font-size: 14px;
  margin-bottom: 2px;
}

.minimal-desc {
  display: block;
  color: #5a6c7d;
  font-size: 13px;
  line-height: 1.4;
}

.minimal-info-panel {
  margin-top: 12px;
  padding: 12px;
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 6px;
}

.minimal-info-content {
  display: flex;
  align-items: flex-start;
  color: #856404;
  font-size: 13px;
}

.minimal-info-content i {
  margin-right: 8px;
  font-size: 14px;
  margin-top: 2px;
}

/* Transiciones para el formulario */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateX(-20px);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

.section-disabled {
  position: relative;
  overflow: hidden;
}

.disabled-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(52, 58, 64, 0.85);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 8px;
}

.disabled-content {
  text-align: center;
  color: white;
  padding: 32px 24px;
  max-width: 300px;
}

.disabled-content i {
  font-size: 40px;
  margin-bottom: 16px;
  opacity: 0.9;
  color: #ffc107;
}

.disabled-content h5 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
  color: white;
}

.disabled-content p {
  color: rgba(255, 255, 255, 0.95);
  line-height: 1.5;
  font-size: 14px;
  margin-bottom: 0;
  font-weight: 400;
}

.disabled-content .btn {
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 6px;
  border: none;
  transition: all 0.2s ease;
}

.disabled-content .btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
}

.content-blurred {
  filter: blur(2px);
  opacity: 0.6;
  pointer-events: none;
}

.custom-checkbox {
  position: relative;
  min-height: 20px;
  margin-right: 10px;
}

.custom-checkbox-label .checkmark {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #ddd;
  border-radius: 4px;
  background-color: #fff;
  transition: all 0.3s ease;
  margin-right: 10px;
}

.custom-checkbox-label input[type="checkbox"]:checked+.checkmark {
  background-color: #3498db;
  border-color: #3498db;
}

.custom-checkbox-label input[type="checkbox"]:checked+.checkmark:after {
  content: "";
  position: absolute;
  left: 6px;
  top: 2px;
  width: 6px;
  height: 12px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.custom-checkbox-label:hover .checkmark {
  border-color: #3498db;
}

/* Estilos personalizados para los checkboxes */
.custom-checkbox {
  width: 17px;
  height: 17px;
  margin-top: 0;
  margin-right: 5px;
  cursor: pointer;
}

/* Asegurar que los formularios tengan el espaciado correcto */
.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

/* Asegurar que los elementos que ocupan todo el ancho tengan el ancho correcto */
.w-100 {
  width: 100% !important;
}

/* Responsive */
@media (max-width: 768px) {
  .col-md-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .form-layout {
    flex-direction: column;
  }

  .table-responsive {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Integraciones/BusinessCentral/Productos/ProductoFormCompleto.vue